import { db } from "./database";
import store from "./store";

export const getCart = (id, dataType, carts) => {
  let productDetails = {
    qty: 0,
    price: 0
  };
  carts.forEach(cart => {
    if (id == cart.vendorProductId) {
      // productDetails = cart;
      productDetails = { qty: cart.qty, price: cart.price };
    }
  });
  if (dataType == "qty") {
    return productDetails.qty;
  }
  if (dataType == "price") {
    return productDetails.price;
  }
};

export const addToCart = (
  vendorProductId,
  productId,
  cartqty,
  unitType,
  sellprice,
  type,
  uid,
  vendorId
) => {
  let value = 0.5;
  if (unitType == "unit") {
    value = 1;
  }
  const vendorProduct = store.state.vendorProducts;
  const isAvail = vendorProduct.find(pd => pd.productsId === productId);
  if (isAvail.stock < cartqty + value) {
    if (type === "plus") {
      return alert("Sorry Product is not in stock");
    }
  }
  if (type == "plus") {
    let currentqty = value + cartqty;
    let amount = sellprice * currentqty;
    db.ref("carts/" + uid + "/" + vendorProductId).set({
      createdAt: Math.round(+new Date() / 1000),
      price: amount,
      productId: productId,
      qty: currentqty,
      vendorProductId: vendorProductId,
      vendorId: vendorId
    });
  } else {
    let currentqty = cartqty - value;
    let amount = sellprice * currentqty;
    if (cartqty != 0) {
      db.ref("carts/" + uid + "/" + vendorProductId).set({
        createdAt: Math.round(+new Date() / 1000),
        price: amount,
        productId: productId,
        qty: currentqty,
        vendorProductId: vendorProductId,
        vendorId: vendorId
      });
      if (currentqty == 0) {
        db.ref("carts/" + uid + "/" + vendorProductId).remove();
      }
    } else {
      db.ref("carts/" + uid + "/" + vendorProductId).remove();
    }
  }
};
